import { IStoreRootState } from "@/store/interface";
import { Module } from "vuex";
import { PaymentRequirementsOutgoingState } from "./interface";
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import { namespace } from "vuex-class";
import { PAYMENT_REQUIREMENTS_MODULE_NAME } from "../constants";
import { PAYMENT_REQUIREMENTS_OUTGOING_MODULE_NAME } from "./constants";

export const PaymentRequirementsOutgoingStore = namespace(
	`${PAYMENT_REQUIREMENTS_MODULE_NAME}/${PAYMENT_REQUIREMENTS_OUTGOING_MODULE_NAME}`
);

export default <Module<PaymentRequirementsOutgoingState, IStoreRootState>> {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}